import { styled, Box } from "@mui/material";

export const MarkdownContent = styled(Box)({
  fontFamily: "Inter",
  fontSize: "13px !important",
  fontWeight: 400,
  lineHeight: 1.4,
  color: "#344054",
  wordBreak: "break-word",
  
  // Parágrafos
  "& p": {
    margin: "0 0 12px 0",
    fontSize: "13px !important",
    "&:last-child": {
      marginBottom: 0,
    },
  },
  
  // Força fontSize 13px em texto direto e spans
  "& span, & div:not(:has(*))": {
    fontSize: "13px !important",
  },
  
  // Títulos
  "& h1, & h2, & h3, & h4, & h5, & h6": {
    fontWeight: 600,
    marginTop: 16,
    marginBottom: 8,
    lineHeight: 1.3,
    "&:first-of-type": {
      marginTop: 0,
    },
  },
  
  "& h1": { fontSize: "18px !important" },
  "& h2": { fontSize: "16px !important" },
  "& h3": { fontSize: "14px !important" },
  "& h4, & h5, & h6": { fontSize: "13px !important" },
  
  // Listas
  "& ul, & ol": {
    margin: "8px 0 12px 0",
    paddingLeft: 24,
    "&:last-child": {
      marginBottom: 0,
    },
  },
  
  "& li": {
    marginBottom: 6,
    fontSize: "13px !important",
    "&:last-child": {
      marginBottom: 0,
    },
  },
  
  // Listas numeradas
  "& ol": {
    listStyleType: "decimal",
  },
  
  // Listas não ordenadas
  "& ul": {
    listStyleType: "disc",
  },
  
  // Negrito
  "& strong": {
    fontWeight: 600,
    color: "#1D2939",
    fontSize: "13px !important",
  },
  
  // Itálico
  "& em": {
    fontStyle: "italic",
    fontSize: "13px !important",
  },
  
  // Código inline
  "& code": {
    backgroundColor: "rgba(0, 164, 159, 0.08)",
    padding: "2px 6px",
    borderRadius: 4,
    fontSize: 12,
    fontFamily: "'Courier New', monospace",
    color: "#00A49F",
  },
  
  // Bloco de código
  "& pre": {
    backgroundColor: "#F9FAFB",
    padding: 12,
    borderRadius: 6,
    overflow: "auto",
    margin: "8px 0 12px 0",
    border: "1px solid #EAECF0",
    "& code": {
      backgroundColor: "transparent",
      padding: 0,
      color: "#344054",
    },
  },
  
  // Links
  "& a": {
    color: "#00A49F",
    textDecoration: "none",
    fontSize: "13px !important",
    "&:hover": {
      textDecoration: "underline",
    },
  },
  
  // Citações
  "& blockquote": {
    borderLeft: "3px solid #00A49F",
    paddingLeft: 12,
    margin: "8px 0 12px 0",
    color: "#475467",
    fontStyle: "italic",
    fontSize: "13px !important",
  },
  
  // Tabelas
  "& table": {
    borderCollapse: "collapse",
    width: "100%",
    margin: "8px 0 12px 0",
  },
  
  "& th, & td": {
    border: "1px solid #EAECF0",
    padding: "8px 12px",
    textAlign: "left",
    fontSize: "13px !important",
  },
  
  "& th": {
    backgroundColor: "#F9FAFB",
    fontWeight: 600,
  },
  
  // Linha horizontal
  "& hr": {
    border: "none",
    borderTop: "1px solid #EAECF0",
    margin: "16px 0",
  },
});

// Manter o MessageText para compatibilidade
export const MessageText = styled(Box)({
  fontFamily: "Inter",
  fontSize: 13,
  fontWeight: 400,
  lineHeight: 1.4,
});
